import { Folder, Flows } from './Types/Folder';
import { NormalizedSidebarData, Space } from './Types/Sidebar';
import { FluxObject } from '../components/Layout/LayoutBeta/AgentsSidebar/context';

export const normalizeFolders = (
  folders: Folder[],
): {
  foldersMap: Record<string, Folder>;
  flowsMap: Record<string, Flows>;
  folderHierarchy: Record<string, string[]>;
  flowToFolder: Record<string, string>;
} => {
  const foldersMap: Record<string, Folder> = {};
  const flowsMap: Record<string, Flows> = {};
  const folderHierarchy: Record<string, string[]> = {};
  const flowToFolder: Record<string, string> = {};

  const processFolder = (folder: Folder, parentId?: string) => {
    const folderCopy = {
      ...folder,
      flows: folder.flows ? [...folder.flows] : [],
      folders: folder.folders ? [...folder.folders] : [],
    };
    foldersMap[folder.id] = folderCopy;

    if (parentId) {
      if (!folderHierarchy[parentId]) {
        folderHierarchy[parentId] = [];
      }
      folderHierarchy[parentId].push(folder.id);
    }

    if (folder.flows && folder.flows.length > 0) {
      folder.flows.forEach((flow) => {
        flowsMap[flow.id] = flow;
        flowToFolder[flow.id] = folder.id;
      });
    }

    if (folder.folders && folder.folders.length > 0) {
      folder.folders.forEach((subfolder) => {
        processFolder(subfolder, folder.id);
      });
    }
  };

  folders.forEach((folder) => processFolder(folder));

  return {
    foldersMap,
    flowsMap,
    folderHierarchy,
    flowToFolder,
  };
};

export const normalizeSpaces = (spaces: Space[]): Record<string, Space> => {
  const spacesMap: Record<string, Space> = {};
  const flowsMap: Record<string, Flows> = {};

  spaces.forEach((space) => {
    space.folder?.forEach((folder) => {
      folder.flows?.forEach((flow) => {
        flowsMap[flow.id] = flow;
      });
    });
    space.flows?.forEach((flow: any) => {
      flowsMap[flow.id] = flow;
    });

    spacesMap[space.id] = {
      ...space,
      folder: space.folder || [],
      flows: space.flows || [],
    };
  });

  return spacesMap;
};

export const denormalizeFolders = (
  foldersMap: Record<string, Folder>,
  folderHierarchy: Record<string, string[]>,
): Folder[] => {
  const rootFolders: Folder[] = [];

  const buildFolder = (folderId: string): Folder => {
    const folder = foldersMap[folderId];
    if (!folder) {
      throw new Error(`Folder ${folderId} not found`);
    }

    const subfolderIds = folderHierarchy[folderId] || [];
    const subfolders = subfolderIds.map(buildFolder);

    return {
      ...folder,
      folders: subfolders,
    };
  };

  Object.keys(foldersMap).forEach((folderId) => {
    const isRoot = !Object.values(folderHierarchy).some((children) =>
      children.includes(folderId),
    );
    if (isRoot) {
      rootFolders.push(buildFolder(folderId));
    }
  });

  return rootFolders;
};
